import { reactive } from 'vue'
// import { authDB, getToken, setToken, removeToken } from '@/utils/auth'

export const Store = reactive({
  thisYear: new Date().getFullYear(),

  token: '',
  resetToken(val) {
    return new Promise(resolve => {
      this.token = val
      // removeToken()
      resolve()
    })    
  },

  largeScreen: (window.innerWidth >= 1200 ? true : false),
  changeScreen() {
    if (window.innerWidth < 1200) {
      this.largeScreen = false;
    } else {
      this.largeScreen = true;
    }
  },

  lang: 'en',
  changeLang(val) { 
    this.lang = val;
  },

  preIndex: '1',
  changePreIndex(val) {
    this.preIndex = val;
  },

  province: localStorage.getItem('province') ? localStorage.getItem('province') : '福建',
  changeProvince(val) { 
    this.province = val;
    localStorage.setItem('province', this.province);
    // console.log('Province:', this.province)
  },
})